const loaderStyles = ({ size, center }) => ({
  width: size,
  height: size,
  ...center && {
    display: "flex",
    width: "100%",
    justifyContent: "center"
  }
});
export {
  loaderStyles
};
